import React from 'react'
import { Box, Button, Link, Typography } from "@mui/material"
import CustomButton from "../../../components/CustomButton"
// import { customTheme as theme } from "../../../theme/customTheme"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import CustomCard from '../../events/components/CustomCard'
import { updateReviewState } from "../../../redux/reviewSlice"
import useAcceptFinalVideo from '../hooks/useAcceptFinalVideo'
import celebrationImage from "../../../assets/celebration.svg";
import { downloadS3File } from '../../../utils/commonServices'
import { useNavigate } from 'react-router-dom/dist'
import usePermissions from '../../../hooks/usePermissions'
import { PERMISSION } from '../../../constants/constants'
import useCustomTheme from '../../../theme/useCustomTheme'
import { Celebration } from '@mui/icons-material'
import CelebrationImage from '../../events/components/assets/CelebrationImage'


const FinalVideoCompletedCard = (props) => {
    const {eventPage} = props; 
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const reviewEventReducer = useSelector((state)=> state.reviewEventReducer)
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [acceptFinalVideoMutate ,finalVideoUrl , finalVideoLoading] = useAcceptFinalVideo()
    const [hasPermission] = usePermissions()
    const [theme ] = useCustomTheme()
   
  
    const finalVideoDownloadHandler =  ()=>{
        downloadS3File(commonReducer.event_details?.final_video_download_url)
       // console.log('Video download')// download video 
        // const url = 'https://s3.us-central-1.wasabisys.com/files-storage-staging/final_video/2/wasabi_sample.mp4';
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', 'video.mp4');
        // link.target = '_blank';
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);  
    }



    return (
        <CustomCard  style={{height:'100%', }} >
        <Box sx={{display:'flex', height:'100%', width:'100%', }}>
    
            <Box  gap={{xs:0,md:1}} sx={{display:'flex', flexDirection:'column', paddingLeft:{xs:'10px',sm:'20px',md:'30px',lg:'34px',xl:'44px'}, paddingTop:{xs:'12px',sm:'16px',md:'20px',lg:'27px', xl:'29px'}, paddingBottom:{xs:'12px',sm:'16px',md:'18px',lg:'25px', xl:'20px'},height:'100%' , justifyContent:'center', alignItems:'start', width:'60%'}}>
    
                <Typography mt={0.6} sx={{fontSize:{xs:'12px',sm:'13px',md:'13px',lg:'14px',xl:'20px'}, fontWeight:600, letterSpacing:0, fontFamily:'Rubik'}}>Congratulations! Your Lucivideo is complete.</Typography>
                  
                 <Typography sx={{fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, display:'inline', textDecoration:'none', width:'100%', fontFamily:'Rubik', letterSpacing:'-0.05px'}} mb={1}>Here is your final video. Enjoy!</Typography>

                { eventPage ? 
                //hasPermission(PERMISSION.PROJECT.REVISION.FINAL_VIDEO.VIEW) && 
                <CustomButton 
                  btnText='Watch Now'
                  disabled = {!hasPermission(PERMISSION.PROJECT.REVISION.FINAL_VIDEO.VIEW)}
                  onClick={()=>navigate('/completedevent', {replace: true})} 
                  component='button'
                  type='button'
                  color='secondary'
                  variant='contained'
                  style={{
                  borderRadius: '5px',
                  border: "none",          
                  textTransform:'none',
                  // backgroundColor:theme.palette.secondary.main
                  }}
                  sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'110px',sm:'130px',md:'150px',lg:'160px',xl:'195px'}, fontFamily:'Rubik', marginBottom:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}}}
                >Download your Lucivideo</CustomButton>
                : //hasPermission(PERMISSION.PROJECT.REVISION.FINAL_VIDEO.DOWNLOAD) && 
                <CustomButton 
                  btnText='Download your Lucivideo'
                  disabled = {!hasPermission(PERMISSION.PROJECT.REVISION.FINAL_VIDEO.DOWNLOAD)}
                  onClick={finalVideoDownloadHandler} 
                  component='button'
                  color='secondary'
                  type='button'
                  variant='contained'
                  style={{
                  borderRadius: '5px',
                  border: "none",          
                  textTransform:'none',
                  // backgroundColor:theme.palette.secondary.main
                  }}
                  sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'110px',sm:'130px',md:'150px',lg:'160px',xl:'230px'}, fontFamily:'Rubik', marginBottom:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}}}
                >Download your Lucivideo</CustomButton>}
            
            </Box>
    
            <Box  sx={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' ,width:'40%',  }} textAlign='right'>    
                  <CelebrationImage sx={{height:'100%', width: '100%'}} />
                {/* <img src={celebrationImage} alt='edit' height='100%' width='100%' />       */}
            </Box>
            </Box>
        </CustomCard>
      )
}

export default FinalVideoCompletedCard